import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageCircle, MapPin, Facebook, Twitter, Linkedin, Youtube } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <h3>UniLearn</h3>
              <p className="brand-tagline">Moodle Cloud Services</p>
              <p className="brand-description">
                Especialistas en soluciones Moodle para instituciones educativas. 
                Transformamos la educación digital con tecnología de vanguardia 
                y soporte experto.
              </p>
            </div>
            
            <div className="footer-social">
              <h4>Síguenos</h4>
              <div className="social-links">
                <a href="#" aria-label="Facebook" className="social-link">
                  <Facebook />
                </a>
                <a href="#" aria-label="Twitter" className="social-link">
                  <Twitter />
                </a>
                <a href="#" aria-label="LinkedIn" className="social-link">
                  <Linkedin />
                </a>
                <a href="#" aria-label="YouTube" className="social-link">
                  <Youtube />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Servicios</h4>
            <ul className="footer-links">
              <li><a href="#servicios">Moodle Cloud Hosting</a></li>
              <li><a href="#servicios">Administración Completa</a></li>
              <li><a href="#servicios">Migración de Datos</a></li>
              <li><a href="#servicios">Personalización Avanzada</a></li>
              <li><a href="#servicios">Soporte Técnico 24/7</a></li>
              <li><a href="#servicios">Capacitación y Consultoría</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Recursos</h4>
            <ul className="footer-links">
              <li><a href="#">Base de Conocimientos</a></li>
              <li><a href="#">Documentación API</a></li>
              <li><a href="#">Guías de Usuario</a></li>
              <li><a href="#">Videos Tutoriales</a></li>
              <li><a href="#">Blog Técnico</a></li>
              <li><a href="#">Casos de Éxito</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Empresa</h4>
            <ul className="footer-links">
              <li><a href="#">Sobre Nosotros</a></li>
              <li><a href="#">Nuestro Equipo</a></li>
              <li><a href="#">Certificaciones</a></li>
              <li><a href="#">Partners</a></li>
              <li><a href="#">Carreras</a></li>
              <li><a href="#">Prensa</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contacto</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <Mail className="contact-icon" />
                <div>
                  <p>contacto@unilearn.cl</p>
                </div>
              </div>
              
              <div className="contact-item">
                <MessageCircle className="contact-icon whatsapp-icon" />
                <div>
                  <a 
                    href="https://wa.me/56992235151?text=Hola,%20me%20interesa%20conocer%20más%20sobre%20los%20servicios%20de%20Moodle" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="whatsapp-link"
                  >
                    WhatsApp
                  </a>
                  <p>Lun-Vie: 9:00-18:00</p>
                </div>
              </div>
              
              <div className="contact-item">
                <MapPin className="contact-icon" />
                <div>
                  <p>Cristóbal Colón 4947</p>
                  <p>Las Condes, Santiago</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-certifications">
          <h4>Certificaciones y Compliance</h4>
          <div className="certifications">
            <div className="cert-item">
              <span className="cert-badge">ISO 27001</span>
              <span>Seguridad de la Información</span>
            </div>
            <div className="cert-item">
              <span className="cert-badge">GDPR</span>
              <span>Protección de Datos</span>
            </div>
            <div className="cert-item">
              <span className="cert-badge">SOC 2</span>
              <span>Controles de Seguridad</span>
            </div>
            <div className="cert-item">
              <span className="cert-badge">Moodle Partner</span>
              <span>Partner Oficial Certificado</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <p>&copy; {new Date().getFullYear()} UniLearn. Todos los derechos reservados.</p>
            <div className="legal-links">
              <Link to="/politica-privacidad">Política de Privacidad</Link>
              <Link to="/eliminacion-datos">Eliminación de Datos</Link>
              <a href="#">Términos de Servicio</a>
              <a href="#">SLA</a>
            </div>
          </div>
          
          <div className="footer-trust">
            <p>
              <strong>Uptime Garantizado:</strong> 99.9% SLA • 
              <strong>Soporte:</strong> 24/7/365 • 
              <strong>Servidores:</strong> Chile y Latinoamérica
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;